import { Button, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { RouterPaths } from '../../../../../../components/Router/Router.constants.ts';
import { useModalsContext } from '../../../../../../providers/ModalsProvider/Modals.context.ts';
import { SyncConversationsEnum } from '../../../../../../providers/SyncConversationsProvider/SyncConversations.enum.ts';
import './SyncConversationsSuccess.styles.scss';

export default function SyncConversationsSuccess() {
  const { syncConversationsStatus, setSyncConversationsStatus } =
    useModalsContext();
  const { t } = useTranslation('dashboard/dashboard');

  return (
    <Modal
      className="SyncConversationsSuccess w-full max-w-4xl"
      open={syncConversationsStatus === SyncConversationsEnum.SUCCESS}
    >
      <div className="SyncConversationsSuccess__Container">
        <div className="SyncConversationsSuccess__Container__Body">
          <img
            src={'/images/sync/syncMobileSuccess.png'}
            alt="syncMobilePhone"
            className="SyncConversationsSuccess__Container__Image"
          />
          <strong className="SyncConversationsSuccess__Container__Title">
            {t('components.modals.SyncConversations.success.title')}
          </strong>
          <p className="SyncConversationsSuccess__Container__Description">
            {t('components.modals.SyncConversations.success.description')}
          </p>

          <div className="SyncConversationsSuccess__Container__Bottom">
            <Button
              color="primary"
              className="text-base-100"
              onClick={() => {
                setSyncConversationsStatus(SyncConversationsEnum.HIDDEN);
                window.open(RouterPaths.funnels, '_self');
              }}
            >
              {t('components.modals.SyncConversations.success.button')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
